import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {
  BI_ORIGINS,
  ChangeRsvpModalMode,
  MembersModal,
  getEventId,
  getEventTitle,
  isNoResponseEnabled,
} from '@wix/wix-events-commons-statics'
import {callAPI, createActions} from '../../../../commons/actions/data-action-helper'
import {setActiveElement} from '../../../../commons/actions/focus-handler'
import {setToast} from '../../../../commons/actions/toast-handler'
import {isPreview} from '../../../../commons/selectors/environment'
import {openDialogModal, openDialogModalOld, openModal, openModalOld} from '../../../../commons/services/modal'
import {getEventRsvp} from '../selectors/event'
import {createAsyncAction} from '../services/redux-toolkit'
import {DetailedEvent, GetState} from '../types/state'

export const DELETE_RSVP_OLD = createActions('DELETE_RSVP_OLD')
export const CANCEL_RSVP_OLD = createActions('CANCEL_RSVP_OLD')

interface CancelRsvpArgs {
  event: DetailedEvent
  returnFocusElement?: string
}

export const cancelRsvpOld =
  ({event, returnFocusElement}: CancelRsvpArgs) =>
  async (dispatch: Function, getState: GetState) => {
    const eventId = getEventId(event.event)
    const eventTitle = getEventTitle(event.event)
    const state = getState()

    if (isPreview(state)) {
      await dispatch(
        openModalOld({
          type: MembersModal.NO_CANCEL_RSVP,
          params: {eventId, origin: BI_ORIGINS.MEMBERS_AREA},
        }),
      )
      dispatch(setActiveElement(hookToAttributeSelector(returnFocusElement)))
    } else {
      return dispatch(
        openDialogModalOld({
          type: MembersModal.UPDATE_RSVP,
          params: {eventId, eventTitle, mode: ChangeRsvpModalMode.MEMBERS_PAGE, origin: BI_ORIGINS.MEMBERS_AREA},
          onConfirm: async () => {
            try {
              await dispatch(onConfirmUpdateRsvpOld(event) as any)
              await dispatch(setToast({skin: 'success', titleKey: 'events.toast.rsvp-cancelled'}))
            } catch (e) {
              await dispatch(setToast({skin: 'error', titleKey: 'events.toast.failed-to-cancel-rsvp'}))
              throw e
            }
          },
          returnFocusElement,
        }),
      )
    }
  }

export const openCancelRsvpModal = createAsyncAction<void, CancelRsvpArgs>(
  'OPEN_CANCEL_RSVP_MODAL',
  async ({event, returnFocusElement}, {getState, dispatch}) => {
    const eventId = getEventId(event.event)
    const eventTitle = getEventTitle(event.event)
    const state = getState()

    if (isPreview(state)) {
      await dispatch(
        openModal({
          type: MembersModal.NO_CANCEL_RSVP,
          params: {eventId, origin: BI_ORIGINS.MEMBERS_AREA},
        }),
      ).unwrap()
      dispatch(setActiveElement(hookToAttributeSelector(returnFocusElement)))
    } else {
      return dispatch(
        openDialogModal({
          type: MembersModal.UPDATE_RSVP,
          params: {eventId, eventTitle, mode: ChangeRsvpModalMode.MEMBERS_PAGE, origin: BI_ORIGINS.MEMBERS_AREA},
          onConfirm: async () => {
            try {
              await dispatch(onConfirmUpdateRsvp(event)).unwrap()
              dispatch(setToast({skin: 'success', titleKey: 'events.toast.rsvp-cancelled'}))
            } catch (e) {
              dispatch(setToast({skin: 'error', titleKey: 'events.toast.failed-to-cancel-rsvp'}))
              throw e
            }
          },
          returnFocusElement,
        }),
      ).unwrap()
    }
  },
)

export const cancelRsvp = createAsyncAction<{eventId: string}, {eventId: string; rsvpId: string}>(
  'CANCEL_RSVP',
  async ({eventId, rsvpId}, {extra: {serverApi}}) => serverApi.cancelRsvp({eventId, rsvpId}),
)

export const deleteRsvp = createAsyncAction<{eventId: string}, {eventId: string; rsvpId: string}>(
  'DELETE_RSVP',
  async ({eventId, rsvpId}, {extra: {serverApi}}) => serverApi.deleteRsvp({eventId, rsvpId}),
)

const onConfirmUpdateRsvpOld = (event: DetailedEvent) => {
  if (isNoResponseEnabled(event.event)) {
    return callAPI(CANCEL_RSVP_OLD, {
      eventId: getEventId(event.event),
      rsvpId: getEventRsvp(event).id,
    })
  } else {
    return callAPI(DELETE_RSVP_OLD, {
      eventId: getEventId(event.event),
      rsvpId: getEventRsvp(event).id,
    })
  }
}

const onConfirmUpdateRsvp = (event: DetailedEvent) => {
  const eventId = getEventId(event.event)
  const rsvpId = getEventRsvp(event).id

  return isNoResponseEnabled(event.event) ? cancelRsvp({eventId, rsvpId}) : deleteRsvp({eventId, rsvpId})
}
